import { createStore, createStateHook, type Action, createActionsHook } from 'react-sweet-state';

type State = {
	isMenuOpen: boolean;
};

const initialState: State = {
	isMenuOpen: false,
};

const actions = {
	setIsMenuOpen:
		(isMenuOpen: boolean): Action<State> =>
		({ setState }) => {
			setState({ isMenuOpen });
		},
};

const Store = createStore({
	initialState,
	actions,
	name: 'more-actions-menu-store',
});

export const useMoreActionsMenuState = createStateHook(Store);
export const useMoreActionsMenuActions = createActionsHook(Store);
